var sessionTimeout = parseFloat($("input[data-timeexpiration]").attr("data-timeexpiration")) * 60;
var idleTime = 0;
var geolocationHelper = require('../geolocation/geolocationHelper');

/**
 * Reinicio de evento por tiempo
 */
function resetTimer() {
    idleTime = 0;  // Reiniciar el tiempo de inactividad
}

/**
 * Function to close/hide all open modals
 *
 */
function closeOpenModals() {
    if ($(".modal.show").length > 0) {
        $(".modal.show").modal("hide");
    }
};

/**
 * Deletes a cookie with the given name.
 *
 * @param {string} cookieName - The name of the cookie to delete.
 */
function deleteCookie(cookieName) {
    // Set the expiration date to a date in the past to delete the cookie
    document.cookie = cookieName + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
}

/**
 * Contador de inactividad
 */
function handleIdle() {
    var isloguer = $(".is-authenticated-header").length; 
    var expireenable = $("input[data-expireenable]").attr("data-expireenable") === 'true' ? true : false;
    var url = $("input[data-urllogout]").attr("data-urllogout");
    var isCo = $("input[data-ischeckuot]").attr("data-ischeckuot") === 'true' ? true : false;

    if (expireenable && isloguer) {
        $.ajax({
            url: url,
            type: 'get',
            success: function(response) {
                closeOpenModals();
                $("#caducatedSession").modal("show");
                $(".timeOutLogued").removeClass("d-none");
                $('.mit-modal-iframe').hide()
                // window.location.href = response.redirectUrl;
            },
            error: function(xhr, status, error) {
                var errorTest = error;
            }
        })
    } else if (expireenable && !isloguer && isCo) {
        closeOpenModals();
        $("#caducatedSessionGuest").modal("show");
        if ($("#myFrame:visible").length) {
            var mitOrderCookie = geolocationHelper.getCookie('lastMitOrderCreated');
            var lastMitOrder = JSON.parse(mitOrderCookie);
            $('.mit-modal-iframe').addClass('index-zero');
            $.ajax({
                url: $('#fail-order-mit').data('url'),
                method: 'POST',
                data: {failnote: $('#close-page').data('message'), orderId : lastMitOrder.orderID},
                success: function () {
                    deleteCookie('lastMitOrderCreated');
                }
            });
        }
        $(".btn-continue-shopping").removeClass("d-none");
        $(".timeOutGuest").removeClass("d-none");
    }
}

var idleTimerId = null;

/**
 * Start the idle timer.
 */
function startIdleTimer() {
    idleTimerId = setTimeout(function () {
        handleIdle();
    }, sessionTimeout * 1000);
}

/**
 * Cancel the idle timer.
 */
function cancelIdleTimer() {
    if (idleTimerId) {
        clearTimeout(idleTimerId);
        idleTimerId = null;
    }
}

// trigger to cancel the idle timer from anywhere in the page
$(document).on('cancelIdleTimer', function() {
    cancelIdleTimer();
});

// trigger to start the idle timer from anywhere in the page
$(document).on('startIdleTimer', function() {
    startIdleTimer();
});

/**
 * Check if the resolution is for a mobile device.
 */
function setOgImage() {
    // Buscar si ya existe una meta tag con property="og:image"
    var metaOgImage = document.querySelector('meta[property="og:image"]');

    // Si no existe, la creamos
    if (!metaOgImage) {
        // Crear una nueva meta tag
        metaOgImage = document.createElement('meta');
        metaOgImage.setAttribute('property', 'og:image');

        // Buscar la primera imagen en la página
        var firstImage = document.querySelector('.photo-tile-image');
        if (firstImage) {
            metaOgImage.setAttribute('content', firstImage.src);
        } else {
            return;
        }

        // Insertar la nueva meta tag en el <head>
        document.head.appendChild(metaOgImage);
    }
}

/**
 * Apply styles to promo banner.
 * @returns {string} returned  safari version.
 */
function detectSafariVersion() {
    var ua = navigator.userAgent;
    var isSafari = /^((?!chrome|android).)*safari/i.test(ua);
    var safariVersion = false;
    
    if (isSafari) {
        var versionMatch = ua.match(/Version\/([0-9._]+)/);
        if (versionMatch && versionMatch[1]) {
            safariVersion = versionMatch[1].split(".")[0];
        }
    }
    return safariVersion;
}


/**
 * Hide the banner promotions.
 */
function hiddenBannerPromotions() {
    $(".accordion-content.banner-item-promo").css('display', 'none');
    document.getElementsByClassName('mayorque')[0].style.display = 'none';
    document.getElementsByClassName('menorque')[0].style.display = '-webkit-inline-box';
    document.getElementsByClassName('mayorque-mob')[0].style.display = '-webkit-inline-box';
    document.getElementsByClassName('menorque-mob')[0].style.display = 'none';
}

/**
 * Check if the resolution is for a mobile device.
 * @param {int} getCalculateWidth - get checkboc group
 * @param {*} contentData - get checkboc group
 * @param {int} getCalculateHeight - get checkboc group
 */
function calculateSizeInPromo(getCalculateWidth, contentData, getCalculateHeight) {
    if (!contentData) {  // Verifica si contentData es null, undefined o una cadena vacía
        var $accordion128 = $('.accordion-ic128');
        var $accordion128Mobile = $('.accordion-ic128-mobile');
        var $bannerItemPromo = $('.banner-item-promo > .html-slot-container-ic128 > p');
        var $bannerItemPromoImg = $('.banner-item-promo > .html-slot-container-ic128 > p > a > img, .banner-item-promo > .html-slot-container-ic128 > p > img');
        var $bannerItemPromoMob = $('.banner-item-promo-mob > .html-slot-container-ic128 > p');
        var bannerHidden = sessionStorage.getItem("banner-hidden");
        var path = (window.location && window.location.pathname) ? window.location.pathname : "/"; 
        path = path.replace(/\/{2,}/g, "/"); 
        var isHome = (path === "/" || path === ""); 
        if ($accordion128.length && $accordion128Mobile.length && $bannerItemPromo.length && $bannerItemPromoImg.length && $bannerItemPromoMob.length) {
            var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
            if (getCalculateWidth > 1200) {
                $accordion128.css('display', 'flex');
                $accordion128Mobile.css('display', 'none');
                $bannerItemPromo.css('margin-bottom', '0px');
                if (isFirefox) {
                    $('.banner-item-bottom').css('width', '50px');
                    $bannerItemPromoImg.css('max-width', 'calc(100vw - 38px)');
                }
                if ((bannerHidden && bannerHidden === 'true') || !isHome) {
                    hiddenBannerPromotions();
                }
               
            } else if (getCalculateWidth > 992) {
                $accordion128.css('display', 'flex');
                $accordion128Mobile.css('display', 'none');
                $bannerItemPromo.css('margin-bottom', '0px');                
                if (isFirefox) {
                    $('.banner-item-bottom').css('width', '50px');
                    $bannerItemPromoImg.css('max-width', 'calc(100vw - 38px)');
                }
                if ((bannerHidden && bannerHidden === 'true') || !isHome) {
                    hiddenBannerPromotions();
                } 
            } else if (getCalculateWidth > 768) {
                $accordion128.css('display', 'flex');
                $accordion128Mobile.css('display', 'none');
                $bannerItemPromo.css('margin-bottom', '0px');
                if (isFirefox) {
                    $('.banner-item-bottom').css('width', '50px');
                    $bannerItemPromoImg.css('max-width', 'calc(100vw - 38px)');
                }
                if ((bannerHidden && bannerHidden === 'true') || !isHome) {
                    hiddenBannerPromotions();
                }
            } else if (getCalculateWidth > 430) {
                if (isFirefox) {
                    $('.banner-item-bottom').css('width', '50px');
                    $bannerItemPromoImg.css('max-width', 'calc(100vw - 38px)');
                }
                $accordion128.css('display', 'flex');
                $accordion128Mobile.css('display', 'none');
                $bannerItemPromo.css('margin-bottom', '0px');
                if ((bannerHidden && bannerHidden === 'true') || !isHome) {
                    hiddenBannerPromotions();
                }
            } else {
                $accordion128.css('display', 'none');
                $bannerItemPromoMob.css('margin-bottom', '0px');
                $accordion128Mobile.css('display', 'grid');
                $bannerItemPromoMob.find("img").css('max-width', '100%');
            }
        }
    }
}


/**
 * Hidde scroll to body.
 * @param {*} $menu - html element
 */ 
function toggleOverflow($menu) {
    let menu = $menu;
    if (menu.hasClass('in')) {
        $('body').css('overflow', 'hidden');
    } else {
        $('body').css('overflow', 'auto');
    }
}

const promotionalBanner = $('.promotional-banner-title');
const callout = $('.html-slot-container-ic128').data('callout');
if (promotionalBanner && callout) {
    $('.promotional-banner-title').html('<span class="banner-title">'+callout+'</span>');
    $('.icons-le-mob').html('<span class="banner-title">'+callout+'</span>');
} else if (promotionalBanner) {
    let defaultText = $('.promotional-banner-title').data('default-text');
    $('.promotional-banner-title').html('<span>'+defaultText+'</span>');
    $('.icons-le-mob').html('<span>'+defaultText+'</span>');
}

$(document).ready(function(){
    var $menu = $('.menu-toggleable-left');
    $menu.on('transitionend', function() {
        toggleOverflow($menu);
    });
    $('.navbar-toggler.icon-menu-mobile').on('click', function() {
        toggleOverflow($menu);
    });
    var safariVersion = detectSafariVersion();
    var contentData = sessionStorage.getItem("ic128-cantentData");
    var isContentOn = document.querySelectorAll('.banner-item-promo > .html-slot-container-ic128 > p').length;
    var isInCo = window.location.href.toLowerCase().includes('checkout');
    var datalayerGTM = $('#datalayerGTM').val();
    if(datalayerGTM) {
        datalayerGTM = JSON.parse(datalayerGTM);
        var isLogged= datalayerGTM.loginGTM;
        var eventGTM = JSON.parse(datalayerGTM.eventGTM);
        if(isLogged){
            window.dataLayer.push(eventGTM);
        }
    }

    if (safariVersion && Number(safariVersion) < 17) {
        $('.banner-item-bottom').css('width', '50px');
        $('.icons-ri').addClass('pt-5');
        $('.icons-le').addClass('align-text-safari');
        $('.icons-ri').addClass('col-10');
        $('.icons-ri').removeClass('col-2');
    }

    if (contentData === 'false' || isInCo || isContentOn === 0) {
        let $accordion128 = $('.accordion-ic128');
        let $accordion128Mobile = $('.accordion-ic128-mobile');

        if ($accordion128.length) {
            $accordion128.css('display', 'none');
        }
        if ($accordion128Mobile.length) {
            $accordion128Mobile.css('display', 'none');
        }
    } else {
        calculateSizeInPromo($(window).width(), contentData, $(window).height());
    }

    $('body').on('click touchend', '.search-mobile button.fa-close', function (e) {
        $(this).removeClass('d-sm-block');
    });

    $(".icon-search").click(function(){
        $(".menu-content-tablet").addClass("d-none");
        $(".search-content-tablet").removeClass("d-none");
    });

    $(".cancel-search").click(function () {
        $(".search-mobile button.fa-close").click();
        $(".menu-content-tablet").removeClass("d-none");
        $(".search-content-tablet").addClass("d-none");
    });

    $('.search-field').on('click', function() {
        if (window.innerWidth >= 992 && window.innerWidth <= 1199) {
            $(this).closest('#search-form').addClass('focused');
            $('.reset-search-btn').removeClass('d-none');
        }
    });

    $('.reset-search-btn').on('click', function() {
        $(this).closest('#search-form').removeClass('focused');
        $('.reset-search-btn').addClass('d-none');
    });

    $('.search-field').on('blur', function() {
        $(this).closest('#search-form').removeClass('focused');
        $('.reset-search-btn').addClass('d-none');
    });

    $(document).on('click', function(event) {
        if (!$(event.target).closest('#search-form').length) {
            $('#search-form').removeClass('focused');
        }
    });

    $(document).on('mousemove keypress touchstart click', resetTimer);

    $('.icon-ic18-cross, .icon-ic18-cross-mob').on('click', function () {
        if (!contentData) {
            sessionStorage.setItem("ic128-cantentData", false);

            let $accordion128 = $('.accordion-ic128');
            let $accordion128Mobile = $('.accordion-ic128-mobile');

            if ($accordion128.length) {
                $accordion128.css('display', 'none');
            }
            if ($accordion128Mobile.length) {
                $accordion128Mobile.css('display', 'none');
            }
        }
    });

    $('.accordion-ic128-mobile, .accordion-ic128').on('click', function () {
        var contentGlobal = document.getElementsByClassName('accordion-ic128')[0];
        var content = document.getElementsByClassName('accordion-content')[0];

        var contentGlobalMobile = document.getElementsByClassName('accordion-ic128-mobile')[0];
        var contentMobile = document.getElementsByClassName('accordion-content-mob')[0];

        var isCokkieVar = contentData == null || contentData == '' || contentData == undefined;

        if (isCokkieVar) {
            if (((contentGlobal.style.display == 'flex' || contentGlobal.style.display == '') && $(window).width() > 430) || contentGlobalMobile.style.display == 'grid') {
                if (((content.style.display == 'flex' || content.style.display == '') && $(window).width() > 430) || contentMobile.style.display == 'grid') {
                    content.style.display = 'none';
                    contentMobile.style.display = 'none';

                    document.getElementsByClassName('mayorque')[0].style.display = 'none';
                    document.getElementsByClassName('menorque')[0].style.display = '-webkit-inline-box';

                    document.getElementsByClassName('mayorque-mob')[0].style.display = '-webkit-inline-box';
                    document.getElementsByClassName('menorque-mob')[0].style.display = 'none';

                    this.parentElement.style.flexGrow = 0;
                    sessionStorage.setItem("banner-hidden", true);
                } else {
                    sessionStorage.setItem("banner-hidden", false);
                    content.style.display = 'flex';
                    contentMobile.style.display = 'grid';

                    document.getElementsByClassName('mayorque')[0].style.display = '-webkit-inline-box';
                    document.getElementsByClassName('menorque')[0].style.display = 'none';

                    document.getElementsByClassName('mayorque-mob')[0].style.display = 'none';
                    document.getElementsByClassName('menorque-mob')[0].style.display = '-webkit-inline-box';

                    this.parentElement.style.flexGrow = 1;
                }
            }
        }
    });

    $(window).resize(function() {
        var calculateWidth = $(window).width();
        var calculateHeight = $(window).height();

        if (!sessionStorage.getItem("ic128-cantentData") && isContentOn > 0) {
            calculateSizeInPromo(calculateWidth, contentData, calculateHeight);
        }
    });

    var windowWidth = $(window).width();

    $(document).on('mouseover', '.catlvl-2 .dropdown-item.dropdown', function () {
        let screenSize = window.innerWidth;
        if (screenSize >= 992) {
            var el = $(this);
            var firstDropdownMenu = el.closest('.dropdown-menu');
            firstDropdownMenu.css("width", "680px");
        }
    });
    
    $(document).on('mouseleave', '.catlvl-2 .dropdown-item.dropdown', function () {
        let screenSize = window.innerWidth;
        if (screenSize >= 992) {
            var el = $(this);
            var firstDropdownMenu = el.closest('.dropdown-menu');
            firstDropdownMenu.removeAttr("style");
        }
    }); 

    setOgImage();
    startIdleTimer();

    /**
     * Detects the version of Firefox.
     * @returns {string} firefox version.
     */
    function getFirefoxVersion() {
        const userAgent = navigator.userAgent;
        const match = userAgent.match(/Firefox\/(\d+\.\d+)/);
        return match ? match[1] : null;
    }
    /**
     * Get the version of Chrome.
     * @returns {string} chrome version.
     */
    function getChromeVersion() {
        const userAgent = navigator.userAgent;
        const match = userAgent.match(/Chrome\/(\d+\.\d+)/);
        return match ? match[1] : null;
    };

    /**
     * Get the version of Edge.
     * @returns {string} edge version.
     */
    function getEdgeVersion() {
        const userAgent = navigator.userAgent;
        const match = userAgent.match(/Edg\/(\d+\.\d+)/);
        return match ? match[1] : null;
    }

    const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    const isChrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
    const isEdge = navigator.userAgent.toLowerCase().indexOf('edge') > -1;
    if (isFirefox || isChrome || isEdge) {
        const firefoxVersion = getFirefoxVersion();
        const errorModal = sessionStorage.getItem('firefoxErrorModal'); // Find modal HTML in sessionStorage to prevent duplicate modals
        const minNumberVersion = 127;
        if (errorModal && firefoxVersion && Number(firefoxVersion) < minNumberVersion) {
            $('body').append(errorModal);
            $('#firefoxErrorModal').modal('show');
            return;
        }

        const chromeVersion = getChromeVersion();
        const chromeMinNumberVersion = 110;
        if (errorModal && chromeVersion && Number(chromeVersion) < chromeMinNumberVersion) {
            $('body').append(errorModal);
            $('#firefoxErrorModal').modal('show');
            return;
        }

        const edgeVersion = getEdgeVersion();
        const edgeMinNumberVersion = 110;
        if (errorModal && edgeVersion && Number(edgeVersion) < edgeMinNumberVersion) {
            $('body').append(errorModal);
            $('#firefoxErrorModal').modal('show');
            return;
        }
        var showModal = (firefoxVersion && Number(firefoxVersion) < minNumberVersion) || (chromeVersion && Number(chromeVersion) < chromeMinNumberVersion) || (edgeVersion && Number(edgeVersion) < edgeMinNumberVersion);
        if (showModal) {
            $.ajax({
                url: $('.get-render-template').val(),
                type: 'get',
                success: function(response) {
                    if (response.htmlRender) {
                        $('body').append(response.htmlRender);
                        $('#firefoxErrorModal').modal('show');
                        sessionStorage.setItem('firefoxErrorModal', response.htmlRender);
                    }
                }
            });
        }
    }

    $.ajax({
        url: $('.session-id').val(),
        type: 'GET',
        success: function(data) {
            if (data.sessionID) {
                window.sessionID = data.sessionID;
            }
        }
    })

    /**
     * Set the user ip in the session
     * @param {string} userIp - The user ip
     */
    function setUserIp(userIp) {
        const urlSetUserIp = $('#data-user-ip').data('set-user-ip');
        $.ajax({
            url: urlSetUserIp,
            type: 'GET',
            data: { userIp: userIp },
            complete: function() {
                $('#data-user-ip').val(userIp);
            }
        });
    }

    const dataUserIp = $('#data-user-ip').val();
    if (!dataUserIp || dataUserIp.length === 0 || dataUserIp === 'undefined' || dataUserIp === 'null' || dataUserIp === 'undefined' || dataUserIp === 'false') {
        // ajax to https://api.ipify.org/ to get the user ip
        $.ajax({
            url: 'https://api.ipify.org/',
            type: 'GET',
            success: function(response) {
                setUserIp(response);
            }
        });
    }

    const chromeVersion = navigator.userAgent.match(/Chrome\/(\d+)/)[1];
    const firstRow = document.querySelector('.banner-item-bottom .row:first-child');

    if (chromeVersion < 114 && firstRow) {
        firstRow.style.minHeight = "420px";
    }
});
